import React from 'react'

interface Props {
    classification: string
    colorID: number
}
const  ClassificationBanner = (props:Props) => {
  return (
    <div className={`bgcolor-${props.colorID} w-100 topbanner`}>
    <div className='sourcesansprosemibold font-12 whitetext text-center'>
      {props.classification.toUpperCase()}
    </div>
  </div>
  )
}
export default ClassificationBanner